module.exports = __webpack_public_path__ + "static/media/reincarnation.fee3083c.png";